import React, { useContext, useState, useEffect } from "react";
import { Menu, Info, SettingsIcon } from "lucide-react";
import { UserStateContext } from "@/contexts/UserStateProvider";
import { _Button } from "@/components/button";
import { Link, useNavigate } from "react-router-dom";
import { CurrencySelect } from "@/components/currency-select";
import { ChartSettingsPopover } from "@/components/chart-settings-popover";
import { SelectDateRange } from "@/components/select-date-range-component";
import { getDateRange } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import SamplesOverview from "./components/samples-overview";

export const SampleStatistics = () => {
  const { isSidebarOpen, setIsSidebarOpen } = useContext(UserStateContext);
  const [selectedDateRange, setSelectedDateRange] = useState("30");
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const navigate = useNavigate();

  const handleDateRangeChange = (from: Date, to: Date) => {
    setFromDate(from);
    setToDate(to);
  };

  return (
    <div className="min-h-screen flex-1 flex flex-col overflow-hidden">
      <main className="bg-background overflow-y-auto min-h-screen">
        <header className="border-b pt-6 pb-4 shadow-sm h-auto flex flex-wrap items-center px-4 md:px-6">
          <div className="lg:w-1/2 w-full flex items-center gap-4">
            <button
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              className="md:hidden text-foreground"
            >
              <Menu size={24} />
            </button>
            <div className="max-w-3xl">
              <div className="flex items-center gap-4">
                <h2 className="text-xl font-semibold text-foreground">
                  Sample Orders Analytics
                </h2>
                <Badge className="bg-purple-500/20 text-purple-500">BETA</Badge>
              </div>
              <div className="flex items-start gap-4">
                <Info className="h-4 w-4 text-blue-500 mt-4 shrink-0" />
                <div className="text-sm text-muted-foreground">
                  View analytics for your sample orders. Sample orders are
                  excluded from your main dashboard calculations. Visit the{" "}
                  <Link
                    className="text-blue-500 underline hover:text-blue-600"
                    to="/dashboard"
                  >
                    Sales & Profit
                  </Link>{" "}
                  to view your main order analytics.
                </div>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 w-full flex items-center justify-end space-x-2">
            <_Button
              onClick={() => navigate("/settings")}
              className="w-auto flex items-center gap-2"
              variant="outline"
              size="sm"
            >
              <SettingsIcon className="w-4 h-4" />
              Settings
            </_Button>
            <ChartSettingsPopover />
            <CurrencySelect />
          </div>
          <div className="pt-6">
            <SelectDateRange
              onDateRangeChange={handleDateRangeChange}
              initialFromDate={fromDate || undefined}
              initialToDate={toDate || undefined}
              initialRange={selectedDateRange}
            />
          </div>
        </header>

        <div>
        {fromDate && toDate && (
            <SamplesOverview fromDate={fromDate} toDate={toDate} />
          )}
        </div>
      </main>
    </div>
  );
};
